import { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const RedirectModule = lazy(() => import('./modules/redirect'));
const HomeModule = lazy(() => import('./modules/home'));
const AuthModule = lazy(() => import('./modules/auth'));
const TicketsModule = lazy(() => import('./modules/tickets'));
const ProfileModule = lazy(() => import('./modules/profile'));
const ChannelsModule = lazy(() => import('./modules/channels'));
const SupportsModule = lazy(() => import('./modules/supports'));
// const ReportModule = lazy(() => import('./modules/reports'));
// const DynamicReportModule = lazy(() => import('./modules/dynamic_report'));
const DynamicReportModule = lazy(() => import('./modules/dynamic-report'));
const Invoicing = lazy(() => import('./modules/invoicing'));
const HelpModule = lazy(() => import('./modules/help'));
const Forbidden = lazy(() => import('./modules/403'));
const NotFound = lazy(() => import('./modules/404'));

function App() {
  return (
    <Routes>
      <Route path="/" element={<RedirectModule />} />
      <Route path="/dashboard" element={<HomeModule />} />
      <Route path="auth/*" element={<AuthModule />} />
      <Route path="tickets/*" element={<TicketsModule />} />
      <Route path="profile/*" element={<ProfileModule />} />
      <Route path="channels/*" element={<ChannelsModule />} />
      <Route path="supports/*" element={<SupportsModule />} />
      {/* <Route path="reports/*" element={<ReportModule />} /> */}
      <Route path="invoicing/*" element={<Invoicing />} />
      <Route path="dynamic-report/*" element={<DynamicReportModule />} />
      <Route path="help/*" element={<HelpModule />} />
      <Route path="403/*" element={<Forbidden />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
